export default {
  login: 'Login',
  placeholderPwd: 'Password ',
  placeholderCode2: 'Captcha',
  placeholderPhone: 'Phone Number',
  ruleAccount: 'Please enter account',
  rulePwd: 'Please enter password',
  ruleErrorCode: 'Please enter correct captcha',
  ruleErrorPhone: 'Please check phone number',
  loginSuccess: 'Login Successful',

  placeholderCode: 'Verification Code',
  ruleCode: 'Please enter the verification code',
  rulePhone: 'Please input your mobile phone number/email',
  placeholderAccount: ' Account / Phone Number / Email',
  placeholderCodeLogin: 'Phone Number / Email',
  passwordLogin: 'Login with password',
  codeLogin: 'Login with code',
  placeholderArea: '请选择国家',
  unlockRightSettlementInfo: 'Unlock the right to create products by simply completing settlement information!',
  providingSettlementProceeds: 'Providing settlement information ensures you receive your sales proceeds promptly.',
  completeNow: 'Complete Now',
  cancel: 'Cancel',
  obtainVerificationCodeFirst: 'Please obtain the verification code first',
  correctMobilePhoneNumberOrEmailAddress: 'Please fill in the correct mobile phone number or email address!',
  ObtainGraphicVerificationCode: 'Please obtain the graphic verification code again'
}
